import { Helmet } from 'react-helmet'
import logo from '../../media/branding/logo.png'
import { useState } from 'react'
import MD5 from 'crypto-js/md5';
import { mainGet } from '../../domain/net/mainApi';

export default function Auth() {
    const [phone, setPhone] = useState('')
    const [pass, setPass] = useState('')
    const [agree, setAgree] = useState(false)

    if (localStorage.getItem('key') && localStorage.getItem('clid')) window.location.href = '/diary/'

    // Маска для номера телефона
    const formatPhoneNumber = (value) => {
        if (!value) return value

        return value.replace(/[^\d]/g, '')
    }

    const handlePhoneChange = (e) => {
        const formattedPhoneNumber = formatPhoneNumber(e.target.value)
        setPhone(formattedPhoneNumber)
    }

    // Проверка номера телефона
    const isValidPhone = (phone) => {
        const cleanPhone = phone.replace(/[^\d]/g, '')
        return cleanPhone.length > 3
    }

    // Проверка пароля
    const isValidPassword = (password) => {
        return password && password.length >= 4
    }

    async function req() {
        if (!isValidPhone(phone)) {
            alert('Пожалуйста, введите корректный номер телефона')
            return
        }

        if (!isValidPassword(pass)) {
            alert('Пароль должен содержать не менее 4 символов')
            return
        }

        const cleanPhone = phone.replace(/[^0-9]/g, '')

        let cleanPass = MD5(pass+"shineonyoucrazydiamond1975").toString();

        try {
            const request = await mainGet({ type: 'checkuser', id: cleanPhone, pass: cleanPass })
            if (!request.data.ok) {
                if (request.data.type === 'cannot fetch server data') alert('Неверный номер телефона или пароль.')
                if (request.data.type === 'unknown DB error') alert('Произошла ошибка базы данных. Повторите попытку позже.')
            } else if (request.data.ok) {
                localStorage.setItem('clid', request.data.data.public_key)
                localStorage.setItem('key', request.data.data.password_key)
                window.location.href = `/diary/`
            }
        } catch (error) {
            alert('Произошла ошибка при подключении к серверу')
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        if (agree) {
            req()
        }
    }

    // Стили для liquid-glass
    const glassStyle = {
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderRadius: '24px',
        border: '1px solid rgba(255, 255, 255, 0.2)',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
    }

    const inputStyle = {
        width: '100%',
        padding: '16px 20px',
        marginBottom: '20px',
        border: '1px solid transparent',
        boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
        borderRadius: '16px',
        fontSize: '16px',
        outline: 'none',
        transition: 'all 0.3s ease',
        background: 'rgba(255, 255, 255, 0.1)',
        backdropFilter: 'blur(10px)',
        color: '#1a1a1a',
        boxSizing: 'border-box'
    }

    const buttonStyle = {
        width: '100%',
        padding: '16px 20px',
        border: 'none',
        borderRadius: '16px',
        fontSize: '16px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.3s ease',
        background: agree ? '#e41655' : '#cbd5e1',
        color: 'white',
        marginTop: '10px'
    }

    const buttonHoverStyle = {
        backgroundColor: agree ? '#c1124a' : '#cbd5e1',
        transform: 'translateY(-2px)'
    }

    return (
        <div className="App" style={{
            minHeight: '100vh',
            backgroundImage: `url(${require('../../media/backgrounds/bg-2.png')})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px'
        }}>
            {/* Затемнение фона */}
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
                backdropFilter: 'blur(5px)',
                zIndex: -1
            }} />

            <Helmet>
                <title>Авторизация</title>
                <link rel="shortcut icon" href={logo} />
                <link
                    rel="stylesheet"
                    href="https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css"
                />
            </Helmet>

            <section className="auth__main" id='active__section' style={{
                width: '100%',
                maxWidth: '450px'
            }}>
                <div style={{
                    ...glassStyle,
                    padding: '50px 40px',
                    textAlign: 'center'
                }} className="animate__animated animate__fadeInUp">
                    <img
                        src={logo}
                        alt="Logo"
                        style={{
                            width: '80px',
                            height: '80px',
                            borderRadius: '16px',
                            marginBottom: '20px'
                        }}
                    />
                    <h1 style={{
                        margin: '0 0 30px 0',
                        fontSize: '32px',
                        fontWeight: '700',
                        color: '#1a1a1a'
                    }}>
                        Авторизация
                    </h1>

                    <form onSubmit={handleSubmit}>
                        <div style={{ marginBottom: '10px' }}>
                            <input
                                value={phone}
                                onChange={handlePhoneChange}
                                placeholder="Ваш ID"
                                type="text"
                                style={inputStyle}
                                onFocus={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                    e.target.style.borderColor = '#3b82f6';
                                }}
                                onBlur={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                }}
                                maxLength="18"
                            />

                            <input
                                value={pass}
                                onChange={e => setPass(e.target.value)}
                                placeholder="Пароль"
                                type="text"
                                style={inputStyle}
                                onFocus={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.2)';
                                    e.target.style.borderColor = '#3b82f6';
                                }}
                                onBlur={(e) => {
                                    e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                                    e.target.style.borderColor = 'rgba(255, 255, 255, 0.3)';
                                }}
                            />
                        </div>

                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            marginBottom: '20px',
                            textAlign: 'left'
                        }}>
                            <input
                                onChange={() => setAgree(!agree)}
                                checked={agree}
                                id='agree-checkbox'
                                style={{
                                    margin: '5px 12px 5px 5px',
                                    width: '18px',
                                    height: '18px',
                                    accentColor: '#e41655'
                                }}
                                type='checkbox'
                            />
                            <label
                                htmlFor='agree-checkbox'
                                style={{
                                    fontSize: '14px',
                                    color: '#6b7280',
                                    lineHeight: '1.4',
                                    cursor: 'pointer'
                                }}
                            >
                                Согласен(-на) с <a
                                style={{
                                    color: '#e41655',
                                    textDecoration: 'none',
                                    fontWeight: '500'
                                }}
                                href='rules.pdf'
                                target='_blank'
                                rel='noopener noreferrer'
                            >Условиями пользования</a>
                            </label>
                        </div>

                        <button
                            type="submit"
                            style={buttonStyle}
                            onMouseOver={(e) => {
                                if (agree) {
                                    e.target.style.backgroundColor = buttonHoverStyle.backgroundColor;
                                    e.target.style.transform = buttonHoverStyle.transform;
                                }
                            }}
                            onMouseOut={(e) => {
                                if (agree) {
                                    e.target.style.backgroundColor = '#e41655';
                                    e.target.style.transform = 'translateY(0)';
                                }
                            }}
                            disabled={!agree}
                        >
                            Войти
                        </button>
                    </form>

                    <div style={{
                        marginTop: '25px',
                        padding: '15px',
                        background: 'rgba(255, 255, 255, 0.15)',
                        borderRadius: '12px',
                        fontSize: '13px',
                        color: '#6b7280',
                        textAlign: 'left'
                    }}>
                        <strong>Подсказка:</strong><br/>
                        • Ваш ID должен содержать только цифры<br/>
                        • Пароль должен содержать не менее 4 символов
                    </div>
                </div>
            </section>
        </div>
    )
}